module.exports = __webpack_public_path__ + "img/22.76039d1d.jpg";